import { useEffect, useState } from "react";
import { NAV, PROFILE } from "@/data/profile";
import { useLenis } from "@/components/LenisProvider";

export const Nav = () => {
  const lenis = useLenis();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    if (lenis) lenis.scrollTo(href, { offset: -64 });
    else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-40 border-b transition-colors duration-500 ${
        scrolled ? "bg-[#e8e3d8]/85 backdrop-blur-md hairline text-[var(--text)]" : "border-transparent text-white"
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-12 h-16">
        <a href="#top" onClick={(e) => go(e, "#top")} data-testid="nav-logo" className="font-display uppercase tracking-wide text-lg flex items-center gap-3">
          <span className="w-3 h-3 bg-[var(--accent)]" />
          <span>Warden Offshore <span className="text-[var(--accent)]">Engineering</span></span>
          <span className={`hidden xl:inline eyebrow ml-2 ${scrolled ? "" : "!text-white/70"}`}>{PROFILE.companyTag}</span>
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={(e) => go(e, n.href)}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className={`eyebrow hover:!text-[var(--accent)] transition-colors duration-300 ${scrolled ? "" : "!text-white/80"}`}
            >
              {n.label}
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          onClick={(e) => go(e, "#contact")}
          data-testid="nav-cta"
          className="btn-industrial bg-[var(--accent)] text-white px-5 py-2 eyebrow !text-white"
        >
          Hire
        </a>
      </div>
    </header>
  );
};
